(function(){
	'use strict';
	angular.module('app.supplyChain')
		.controller('procurementAbcAnalysis', procurementAbcAnalysis);
	procurementAbcAnalysis.$inject = ['$scope', '$timeout', '$state', '$filter', 'leanFilterService', 'tableRenderService', 'tableService', 'navigationService', 'storeService'];

	function procurementAbcAnalysis($scope, $timeout, $state, $filter, leanFilterService, tableRenderService, tableService, navigationService, storeService) {

		var vm = this;

		var unsubscribe;
		var reportSettingsName = 'pq-analysis/abc-analysis';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var defaultFilters = [];
		var rendererParams = {'filterFunction': $filter};
		// Extra drilldown query params to parse
		var extraFilters = [];
		var pinnedColumns = [];
		var setFirstView = false;


		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.showExcel = false;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Purchased inventory by ABC classification';
		vm.baseReportDisplay = vm.reportName;

		vm.showSaveReport = !reportSettingsId;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (!reportSettingsId && !setFirstView) {
					var firstViewObj = {
						'viewType': $state.current.data.viewType
					};
					navigationService.setFirstView(firstViewObj, reportSettingsName);
					setFirstView = true;
				}
				// If any data manipulation is needed, do it here
				createSums(response);
				return response;
			});
		}

		function daysCoverageAggregationFn(totalOnHandValue, totalAvgDailyCost) {
			var returnValue = null;
			if (!isNaN(totalOnHandValue)) {
				if (!isNaN(totalAvgDailyCost) && totalAvgDailyCost != 0) {
					returnValue = totalOnHandValue / totalAvgDailyCost;
				}
			}
			return returnValue;
		}

		function createSums(response){
			var footer = {};
			var dataLength = response[0].data.length;
			var totalAvgDailyCost = 0;
			if (dataLength > 0) {
				var sum = 0;
				angular.forEach(response[0].data, function (row) {
					if (row['abcClass'] !== 'Inactive') {
						sum +=  row['avgDailyCost'];
					}
				});
				angular.forEach(response[0].data, function (row) {
					if (row['abcClass'] !== 'Inactive' && sum != 0) {
						row['avgDailyCostPercent'] =  row['avgDailyCost'] / sum;
					}
				});
				totalAvgDailyCost = sum;
			}
			for (var i = 0; i < columns.length; i++){
				if(columns[i].aggregate == true){
					var sum = 0;
					for(var j = 0; j < response[0].data.length; j++){
						sum += response[0].data[j][columns[i].id];
					}
				}
				else{
					sum = undefined;
				}
				footer[columns[i].id] = sum;
			}
			footer['daysCoverage'] = daysCoverageAggregationFn(footer['actualInventoryValue'], totalAvgDailyCost);
			response['footer'] = footer;
		}

		init();

		var columns = [
			{ 'id': 'abcClass', 'display': 'ABC Class', 'class': 'smallTextCell', 'width':120, 'show': true, 'title': '', 'sort': true,'position':0 },
			{ 'id': 'avgDailyCostPercent', 'display': '% of Avg Daily Cost', 'class': 'buyerCell alignRight', 'width':140, 'renderer': tableRenderService.percent, 'show': true, 'sort': true, 'title': '','position':1 },
			{ 'id': 'itemCount', 'display': 'Number of Items', 'class': 'numberCell', 'width':140,'renderer': tableRenderService.integer, 'show': true, 'title': '', 'sort': true,'aggregate':true,'position':2 },
			{ 'id': 'avgDailyCost', 'display': 'Avg Daily Cost', 'class': 'buyerCell alignRight', 'width':100, 'renderer': tableRenderService.currency, 'show': true, 'sort': true,'aggregate':true,'position':3 },
			{ 'id': 'actualInventoryValue', 'display': 'Current Inventory Value', 'class': 'buyerCell alignRight', 'width':100, 'renderer': tableRenderService.currency, 'show': true, 'sort': true, 'title': '','aggregate':true,'position':4 },
			{ 'id': 'daysCoverage', 'display': 'Days Coverage (Work Days)', 'class': 'buyerCell alignRight', 'width':140, 'renderer': tableRenderService.integer, 'show': true, 'sort': true, 'title': '','aggregate':true,'position':5 }
		];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/PurchasedInventoryByABCClassificationReport',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'overTargetValue',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			hideSearch: true,
			footer:true,
			hasMandatoryFilters: true
		};

		function init() {
			$scope.filterService = leanFilterService;
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			defaultFilters = [{
				'id': 'factory',
				'values': [globalConfig.factory.id],
				'isMandatory': true
			}];
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			$scope.filterService.setMasterFilterList([siteFilter]);
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;

			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});

		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

	}

})();
